<template>
  <b-modal v-model="show" @hide="navigateProfile" centered hide-footer :title="$t('common.notification')">
    <p>{{ $t('common.wait_call') }}</p>

    <div class="mt-3 d-flex justify-content-center">
      <button class="btn btn-sm btn-green" @click="closeOperatorModal">
        {{ $t('buttons.wait_call') }}
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
name: "operatorModal",
  props: {
    show: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  methods:{
    navigateProfile() {
      if (!this.guest) {
        this.$router.push({
          name: 'profile',
        });
      }
    },
    closeOperatorModal() {
      this.$router.push({name:'profile'})
      this.showOperatorModal = false
    },
  }
}
</script>

<style scoped>

</style>
